import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c52f55dc")

_pushScopeId("data-v-c52f55dc")
const _hoisted_1 = { class: "trade-item" }
const _hoisted_2 = { class: "brief df-middle f-md row" }
const _hoisted_3 = { class: "flex-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Symbol")
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "flex-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Margin required")
const _hoisted_8 = { class: "flex-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Direction")
const _hoisted_10 = { class: "flex-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Entry Price")
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "flex-1 t-right" }
const _hoisted_14 = { ref: "acc" }
const _hoisted_15 = { class: "accordion__content more f-md" }
const _hoisted_16 = { class: "row d-f" }
const _hoisted_17 = { class: "flex-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Commission")
const _hoisted_19 = { class: "flex-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("T/P")
const _hoisted_21 = { class: "flex-2" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Quantity")
const _hoisted_23 = { class: "flex-3" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Order Time")
const _hoisted_25 = { class: "row d-f" }
const _hoisted_26 = { class: "flex-2" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Leverage")
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "flex-2" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("S/L")
const _hoisted_31 = { class: "flex-2" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Profit per pip")
const _hoisted_33 = { class: "flex-2" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Maximum Deviation")
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_36 = {
  key: 0,
  class: "tip py-8 f-sm d-f"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Position with coupons will be automatically closed after the market is closed ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_money = _resolveComponent("money")
  const _component_ColorText = _resolveComponent("ColorText")
  const _component_router_link = _resolveComponent("router-link")
  const _component_TheTradeLimitDisplay = _resolveComponent("TheTradeLimitDisplay")
  const _component_Date = _resolveComponent("Date")

  return (_openBlock(), _createBlock("div", {
    class: "anchor",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSlide && _ctx.toggleSlide(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_t, { class: "label" }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.prop('code', _ctx.order)), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_t, {
            path: "symbol_44",
            class: "label"
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_money, {
            class: "value",
            v: _ctx.prop('buyMoney', _ctx.order)
          }, {
            default: _withId(({text}) => [
              _createTextVNode(_toDisplayString(text) + " ", 1),
              (_ctx.byCoupon)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    name: "coupon",
                    class: "c-title",
                    sm: ""
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["v"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_t, {
            path: "symbol_43",
            class: "label"
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_t, { custom: "" }, {
            default: _withId(({td, t}) => [
              _createVNode(_component_ColorText, {
                class: "f-medium",
                display: [t('symbol_10') || 'Sell', t('symbol_9') || 'Buy'],
                value: _ctx.prop('type', _ctx.order) - 2
              }, null, 8, ["display", "value"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_t, {
            path: "symbol_46",
            class: "label"
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.prop('entrustPrice', _ctx.order)), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Icon, {
            name: _ctx.show ? 'caret-up' : 'caret-down',
            class: ["toggle-icon", {up: _ctx.show}],
            sm: ""
          }, null, 8, ["name", "class"]),
          _createVNode(_component_router_link, {
            to: `/edit/${_ctx.prop('code', _ctx.order)}/${_ctx.prop('orderId', _ctx.order)}`,
            custom: ""
          }, {
            default: _withId(({navigate}) => [
              _createVNode(_component_Icon, {
                name: "settings",
                class: "mx-8",
                onClick: _withModifiers(navigate, ["stop"]),
                sm: ""
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_Icon, {
            name: "close",
            class: "bg-primary c-white br-sm",
            onClick: _withModifiers(_ctx.cancel, ["stop"]),
            sm: ""
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode(_component_t, {
                path: "symbol_45",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_money, {
                class: "value",
                v: _ctx.prop('fee', _ctx.order)
              }, null, 8, ["v"])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_t, {
                path: "symbol_48",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_20
                ]),
                _: 1
              }),
              _createVNode(_component_TheTradeLimitDisplay, {
                class: "value",
                value: Number(_ctx.prop('stopProfitPoint', _ctx.order))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_t, { class: "label" }, {
                default: _withId(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode("span", null, _toDisplayString(_ctx.prop('orderNumber', _ctx.order)) + "Lots", 1)
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode(_component_t, {
                path: "symbol_47",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_component_Date, {
                class: "value f-xs",
                format: "MM-dd-yyyy HH:mm:ss",
                time: _ctx.prop('entrustTime', _ctx.order)
              }, null, 8, ["time"])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode(_component_t, {
                path: "transactionhistory_25",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_27
                ]),
                _: 1
              }),
              _createVNode("span", _hoisted_28, "1:" + _toDisplayString(_ctx.prop('lever', _ctx.order)), 1)
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode(_component_t, {
                path: "symbol_49",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_30
                ]),
                _: 1
              }),
              _createVNode(_component_TheTradeLimitDisplay, {
                class: "value",
                value: Number(_ctx.prop('stopLossPoint', _ctx.order))
              }, null, 8, ["value"])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode(_component_t, {
                path: "transactionhistory_29",
                class: "label"
              }, {
                default: _withId(() => [
                  _hoisted_32
                ]),
                _: 1
              }),
              _createVNode("span", null, _toDisplayString(_ctx.order.yk * (_ctx.order.orderNumber / 0.01)) + " " + _toDisplayString(_ctx.prop('ykUnit', _ctx.order)), 1)
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode(_component_t, { class: "label" }, {
                default: _withId(() => [
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode("span", null, _toDisplayString(_ctx.prop('offset', _ctx.order)) + "Pips", 1)
            ]),
            _hoisted_35
          ])
        ])
      ], 512),
      (_ctx.byCoupon)
        ? (_openBlock(), _createBlock("div", _hoisted_36, [
            _createVNode(_component_Icon, {
              name: "warn",
              sm: "",
              class: "mr-4"
            }),
            _createVNode(_component_t, { path: "symbol_19" }, {
              default: _withId(() => [
                _hoisted_37
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})